import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../store';
import { logout } from '../reducers/user';
import { clearAuthToken } from '../utils/auth';
import AppShell from './AppShell';
import MFASetupModal from './MFASetupModal';

const AppShellWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const profile = useSelector((s: RootState) => s.user.profile);
  const isAllowedAdmin = useSelector((s: RootState) => s.user.isAllowedAdmin);
  const isPatientSession = useSelector((s: RootState) => s.user.isPatientSession);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showMFASetup, setShowMFASetup] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('mfa_setup_required') === 'true') {
      setShowMFASetup(true);
    }
  }, []);

  const handleMFASetupComplete = () => {
    sessionStorage.removeItem('mfa_setup_required');
    setShowMFASetup(false);
    navigate('/dashboard');
  };

  const handleMFASetupHide = () => {
    setShowMFASetup(false);
    sessionStorage.removeItem('mfa_setup_required');
    clearAuthToken();
    dispatch(logout());
    navigate('/login');
  };

  return (
    <AppShell profile={profile} isAllowedAdmin={!!isAllowedAdmin} isPatientSession={isPatientSession}>
      {children}
      <MFASetupModal show={showMFASetup} onHide={handleMFASetupHide} onComplete={handleMFASetupComplete} />
    </AppShell>
  );
};

export default AppShellWrapper;
